export default "__VITE_ASSET__D90qJAXa__"